// Angular
import {
  Component,
  Input,
  Output,
  EventEmitter,
 } from '@angular/core';

@Component({
  selector: 'app-cancel-booking-popover',
  templateUrl: './cancel-booking-popover.component.html',
  styleUrls: ['./cancel-booking-popover.component.scss']
})
export class CancelBookingPopoverComponent {

  @Input() title: string;
  @Input() confirmationText: string;
  @Input() bookingOrRequestId: string;
  @Input() cancelPopupConfig: any;

  @Output() closeBookingDetailsCallback = new EventEmitter();
  @Output() dismissCallback = new EventEmitter();
  @Output() approveCallback = new EventEmitter();

  isYesClicked = false;
  reasonText: string;
  isSubmitReasonClicked = false;
  maxLimit = 200;

  constructor() { }

  handleCloseBookingDetails() {
    if (this.closeBookingDetailsCallback) {
      this.closeBookingDetailsCallback.emit();
    }
  }

  onYesClick() {
    this.isYesClicked = true;
  }

  cancelCallback() {
    this.dismissCallback.emit();
  }

  submitReasonAndCancel() {
    this.isSubmitReasonClicked = true;
    if (this.cancelPopupConfig.config.visibility.visible && this.cancelPopupConfig.config.mandatory) {
      if (this.reasonText && this.reasonText.length <= this.maxLimit) {
        this.approveCallback.emit(this.reasonText);
      }
    } else {
      if (this.reasonText) {
        if (this.reasonText.length <= this.maxLimit) {
          this.approveCallback.emit(this.reasonText);
        }
      } else {
        this.approveCallback.emit("");
      }
    }
  }
}
